import React from "react";
import { ICustomHeader } from "../../types/railsTypes";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'web-footer': any;
    }
  }
}

const CustomFooter: React.FC<{ educateProps: ICustomHeader }> = ({
  educateProps,
}) => <>{educateProps ? <web-footer data={JSON.stringify(educateProps)}></web-footer> : null}</>;

export default CustomFooter;
